import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  NgZone,
  ViewChild,
  AfterViewInit,
} from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { Select, Store } from '@ngxs/store';
import {
  DEAFULT_IMAGE_ENTITY,
  IMAGE_PROXY_XL,
  TYPE_ALIGN_CENTER,
  TYPE_ALIGN_LEFT,
  TYPE_ALIGN_RIGHT,
  TYPE_ALIGN_VERTICAL_BOTTOM,
  TYPE_ALIGN_VERTICAL_TOP,
} from '@shared/constants';
import { SharedService } from '@shared/services/shared.service';
import { Entity } from 'app/graphql/interfaces/entityModel';
import { HomeImage, Publication, PublicEntity } from 'app/graphql/types';
import { GetPublicPublications } from 'app/redux/actions/publication.actions';
import { EntityState } from 'app/redux/state/entity.state';
import { PublicationState } from 'app/redux/state/publication.state';
import { SlickCarouselComponent } from 'ngx-slick-carousel/slick.component';
import { Observable } from 'rxjs';

import { DashboardService } from './dashboard.srevice';
import { untilDestroyed } from '@ngneat/until-destroy';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [DashboardService],
})
export class DashboardComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('slickModal') public slickComponent: any;

  @Select(PublicationState.publications)
  publications$: Observable<[Publication]>;

  @Select(EntityState.entity)
  entity$: Observable<PublicEntity>;
  homeImages: HomeImage[] = [];
  entity: Entity = this.store.snapshot().Entity.entity;
  slideConfig = {
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 60000,
    speed: 1000,
    dots: false,
    swipe: true,
    infinite: true,
    centerPadding: '0px',
    arrows: true,
    rows: 1,
  };

  currentSlide = 0;

  animationClassTitle = 'animate__animated animate__fadeInDown';
  animationClassDescription = 'animate__animated animate__zoomIn';
  animationClassButton = 'animate__animated animate__fadeInUp';

  IMAGE_PROXY_XL = IMAGE_PROXY_XL;
  TYPE_ALIGN_CENTER = TYPE_ALIGN_CENTER;
  TYPE_ALIGN_LEFT = TYPE_ALIGN_LEFT;
  TYPE_ALIGN_RIGHT = TYPE_ALIGN_RIGHT;

  TYPE_ALIGN_VERTICAL_TOP = TYPE_ALIGN_VERTICAL_TOP;
  TYPE_ALIGN_VERTICAL_BOTTOM = TYPE_ALIGN_VERTICAL_BOTTOM;

  constructor(
    private dashboardSrv: DashboardService,
    private ngZone: NgZone,
    private store: Store,
    public sharedService: SharedService,
    private translateService: TranslateService,
    private cdr: ChangeDetectorRef,
    private titleService: Title,
    private metaService: Meta
  ) {}

  ngOnInit() {
    this.entity$.subscribe(entity => {
      if (entity) {
        this.homeImages = entity.homeImage.filter(item => item.active == true);
      }
    });

    this.store.dispatch(new GetPublicPublications({}));
    this.titleService.setTitle(
      this.store.snapshot().Entity.entity.name +
        ' | ' +
        this.translateService.instant('seo.home.title')
    );

    this.sharedService.removeAllMetaTags();
    this.metaService.addTags([
      { name: 'keywords', content: this.translateService.instant('seo.home.keywords') },
      {
        name: 'description',
        content: this.entity.name + ' | ' + this.translateService.instant('seo.home.description'),
      },
      {
        property: 'og:title',
        content: this.entity.name + ' | ' + this.translateService.instant('seo.home.title'),
      },
      { property: 'og:url', content: window.location.href },
      { property: 'og:site_name', content: this.entity.name },
      {
        property: 'og:description',
        content: this.entity.name + ' | ' + this.translateService.instant('seo.home.description'),
      },
      {
        property: 'og:image',
        content: this.entity.image
          ? this.sharedService.getImage(this.entity.image)
          : this.sharedService.getImage(DEAFULT_IMAGE_ENTITY),
      },
    ]);

    //this.afterChange(null);
  }

  slickInit(e) {
    this.afterChange(null);
  }
  afterChange(event: any) {
    const currentSlide = event == null ? 0 : event.currentSlide; // Identifica el slide actual
    this.currentSlide = currentSlide;

    const elementsTitle = document.querySelectorAll(`.overlay-title`) as NodeListOf<HTMLElement>;
    elementsTitle.forEach(elementTitle => {
      if (elementTitle) {
        elementTitle.style.visibility = 'hidden';
        this.animationClassTitle.split(' ').forEach(cls => elementTitle.classList.remove(cls));
        void elementTitle.offsetWidth; // Forzar reflow para reiniciar animación
        elementTitle.style.visibility = 'visible';
        this.animationClassTitle.split(' ').forEach(cls => elementTitle.classList.add(cls));
      }
    });

    const elementsDescription = document.querySelectorAll(`.overlay-description`) as NodeListOf<
      HTMLElement
    >;
    elementsDescription.forEach(elementDescription => {
      if (elementDescription) {
        elementDescription.style.visibility = 'hidden';
        this.animationClassDescription
          .split(' ')
          .forEach(cls => elementDescription.classList.remove(cls));
        void elementDescription.offsetWidth; // Forzar reflow para reiniciar animación
        elementDescription.style.visibility = 'visible';
        this.animationClassDescription
          .split(' ')
          .forEach(cls => elementDescription.classList.add(cls));
      }
    });

    const elementsButton = document.querySelectorAll(`.overlay-button`) as NodeListOf<HTMLElement>;
    elementsButton.forEach(elementButton => {
      if (elementButton) {
        elementButton.style.visibility = 'hidden';
        this.animationClassButton.split(' ').forEach(cls => elementButton.classList.remove(cls));
        void elementButton.offsetWidth; // Forzar reflow para reiniciar animación
        elementButton.style.visibility = 'visible';
        this.animationClassButton.split(' ').forEach(cls => elementButton.classList.add(cls));
        //void elementTitle.offsetWidth;
      }
    });

    /*  if (currentSlide == 1) {
      console.log('slide:', currentSlide);
    } */

    //esperar 5 segudos
    /* const elementTitle = document.querySelector(
      `.slider-content-${currentSlide}.overlay-title`
    ) as HTMLElement;
    if (elementTitle) {
      
      elementTitle.style.visibility = 'hidden';
      this.animationClassTitle.split(' ').forEach(cls => elementTitle.classList.remove(cls));
      void elementTitle.offsetWidth; // Forzar reflow para reiniciar animación
      elementTitle.style.visibility = 'visible';
      this.animationClassTitle.split(' ').forEach(cls => elementTitle.classList.add(cls));
      //void elementTitle.offsetWidth;
    }
    const elementDescription = document.querySelector(
      `.slider-content-${currentSlide}.overlay-description`
    ) as HTMLElement;
    if (elementDescription) {
      //elementDescription.style.visibility = 'hidden';
      //this.animationClassDescription.split(' ').forEach(cls => elementDescription.classList.remove(cls));
      //void elementDescription.offsetWidth; // Forzar reflow para reiniciar animación
      elementDescription.style.visibility = 'visible';
      this.animationClassDescription
        .split(' ')
        .forEach(cls => elementDescription.classList.add(cls));
      //void elementDescription.offsetWidth;
    }

    const elementButton = document.querySelector(
      `.slider-content-${currentSlide}.overlay-button`
    ) as HTMLElement;
    if (elementButton) {
      //elementButton.style.visibility = 'hidden';
      //this.animationClassButton.split(' ').forEach(cls => elementButton.classList.remove(cls));
      //void elementButton.offsetWidth; // Forzar reflow para reiniciar animación
      elementButton.style.visibility = 'visible';
      this.animationClassButton.split(' ').forEach(cls => elementButton.classList.add(cls));
      //void elementButton.offsetWidth;
    } */
  }

  beforeChange(event: any) {
    const elementsTitle = document.querySelectorAll(`.overlay-title`) as NodeListOf<HTMLElement>;
    elementsTitle.forEach(elementTitle => {
      if (elementTitle) {
        elementTitle.style.visibility = 'hidden';
        this.animationClassTitle.split(' ').forEach(cls => elementTitle.classList.remove(cls));
        void elementTitle.offsetWidth; // Forzar reflow para reiniciar animación
      }
    });

    const elementsDescription = document.querySelectorAll(`.overlay-description`) as NodeListOf<
      HTMLElement
    >;
    elementsDescription.forEach(elementDescription => {
      if (elementDescription) {
        elementDescription.style.visibility = 'hidden';
        this.animationClassDescription
          .split(' ')
          .forEach(cls => elementDescription.classList.remove(cls));
        void elementDescription.offsetWidth; // Forzar reflow para reiniciar animación
      }
    });

    const elementsButton = document.querySelectorAll(`.overlay-button`) as NodeListOf<HTMLElement>;
    elementsButton.forEach(elementButton => {
      if (elementButton) {
        elementButton.style.visibility = 'hidden';
        this.animationClassButton.split(' ').forEach(cls => elementButton.classList.remove(cls));
        void elementButton.offsetWidth; // Forzar reflow para reiniciar animación
      }
    });
    /* console.log('slidebefore:', event);
    const currentSlide = event == null ? 0 : event.currentSlide; // Identifica el slide actual
    console.log('slidebefore:', currentSlide);
    const elementTitle = document.querySelector(
      `.slider-content-${currentSlide}.overlay-title`
    ) as HTMLElement;
    if (elementTitle) {
      console.log(elementTitle);
      elementTitle.style.visibility = 'hidden';
      this.animationClassTitle.split(' ').forEach(cls => elementTitle.classList.remove(cls));
      console.log(elementTitle.classList);
      void elementTitle.offsetWidth; // Forzar reflow para reiniciar animación
      elementTitle.style.visibility = 'visible';
      this.animationClassTitle.split(' ').forEach(cls => elementTitle.classList.add(cls));
    }
    const elementDescription = document.querySelector(
      `.slider-content-${currentSlide}.overlay-description`
    ) as HTMLElement;
    if (elementDescription) {
      elementDescription.style.visibility = 'hidden';
      this.animationClassDescription
        .split(' ')
        .forEach(cls => elementDescription.classList.remove(cls));
      void elementDescription.offsetWidth; // Forzar reflow para reiniciar animación
      elementDescription.style.visibility = 'visible';
      this.animationClassDescription
        .split(' ')
        .forEach(cls => elementDescription.classList.add(cls));
    }

    const elementButton = document.querySelector(
      `.slider-content-${currentSlide}.overlay-button`
    ) as HTMLElement;
    if (elementButton) {
      elementButton.style.visibility = 'hidden';
      this.animationClassButton.split(' ').forEach(cls => elementButton.classList.remove(cls));
      void elementButton.offsetWidth; // Forzar reflow para reiniciar animación
      elementButton.style.visibility = 'visible';
      this.animationClassButton.split(' ').forEach(cls => elementButton.classList.add(cls));
    } */
  }

  public ngAfterViewInit(): void {
    if (this.slickComponent) {
      setTimeout(() => {
        this.slickComponent.unslick();
        this.slickComponent.initSlick();
      }, 300);
    }
  }

  ngOnDestroy() {}

  filterFunction(t): boolean {
    if (t.active != false) return true;
    return false;
  }
}
